module.exports = __webpack_public_path__ + "img/Rebecca Deasy.9d7147d4.jpg";